import type { TaskBoard, TaskDetail } from '@shared/types/tasks';
import { copyTextWhenReady } from '@/lib/clipboard';
import { getTask } from '@/lib/tasks-api';
import { tasksToMarkdown } from './task-markdown';

/**
 * Copy tasks as Markdown, in the order given. Each is loaded fresh, so its file links last the
 * full hour; a task already on screen (`fallback`) is used if loading it fails. Call from the click.
 */
export function copyTasksMarkdown(
  taskIds: string[],
  meta: Pick<TaskBoard, 'members' | 'labels' | 'columns'>,
  fallback: TaskDetail[] = []
): Promise<void> {
  const markdown = Promise.all(
    taskIds.map(async (id) => {
      const { data, error } = await getTask(id);
      const task = data?.task ?? fallback.find((t) => t.id === id);
      if (!task) throw new Error(error ?? 'Task not found');
      return task;
    })
  ).then((tasks) => tasksToMarkdown(tasks, meta, { origin: window.location.origin }));
  return copyTextWhenReady(markdown).then((ok) => {
    if (!ok) throw new Error('Could not copy');
  });
}
